/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { staticListProductListStyles } from "@insite/content-library/Widgets/StaticList/StaticListProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

staticListProductListStyles.countText = {
    weight: 600,
    css: css`
        margin-bottom: 10px;
        display: block;
    `,
};

staticListProductListStyles.linesWrapper = {
    css: css`
        background: ${getColor("common.background")};
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid ${getColor("common.border")};
    `,
};
